import React, { useEffect, useState } from 'react'

interface BeforeInstallPromptEvent extends Event {
  prompt: () => Promise<void>
  userChoice: Promise<{ outcome: 'accepted' | 'dismissed' }>
}

const AddToHomeScreen: React.FC = () => {
  const [deferredPrompt, setDeferredPrompt] =
    useState<BeforeInstallPromptEvent | null>(null)
  const [showPrompt, setShowPrompt] = useState(false)

  useEffect(() => {
    const handler = (e: Event) => {
      // Store the event for later - still calling preventDefault()
      // but this is expected behavior for custom installation UI
      e.preventDefault()
      // Stash the event so it can be triggered later
      setDeferredPrompt(e as BeforeInstallPromptEvent)
      // Show our custom prompt
      setShowPrompt(true)
    }

    window.addEventListener('beforeinstallprompt', handler)

    return () => {
      window.removeEventListener('beforeinstallprompt', handler)
    }
  }, [])

  const handleInstallClick = async () => {
    if (!deferredPrompt) return

    // Show the install prompt
    deferredPrompt.prompt()

    // Wait for the user to respond to the prompt
    const { outcome } = await deferredPrompt.userChoice

    // Clear the deferredPrompt variable
    setDeferredPrompt(null)
    setShowPrompt(false)
  }

  // If user doesn't want to see the prompt, don't show it
  if (!showPrompt) return null

  return (
    <div className="fixed bottom-4 left-4 right-4 z-[100000] mx-auto max-w-md">
      <div className="bg-white dark:bg-gray-800 p-4 rounded-lg shadow-lg border border-gray-200 dark:border-gray-700">
        <div className="flex items-center justify-between">
          <div className="flex-1">
            <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
              Add to Home Screen
            </h3>
          </div>
          <div className="flex gap-0.5 sm:gap-2">
            <button
              onClick={() => setShowPrompt(false)}
              className="px-2 py-1 text-sm text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 rounded"
            >
              Later
            </button>
            <button
              onClick={handleInstallClick}
              className="px-2 py-1 text-sm text-white bg-blue-600 hover:bg-blue-700 rounded"
            >
              Install
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AddToHomeScreen
